import { createStandardAction } from 'typesafe-actions'
import { Extents } from 'types/Extents'

/**
 * Action for updating the extent in the store
 */
export const currentExtentsUpdate = createStandardAction(
  'EXTENTS/CURRENT/UPDATE'
)<Extents>()
export const overallExtentsUpdate = createStandardAction(
  'EXTENTS/OVERALL/UPDATE'
)<Extents>()
